import { action, makeObservable, observable } from "mobx";

export class CountryStore {
	@observable countryCode: string = "";

	constructor() {
		makeObservable(this);
	}

	@action.bound
	async getCountry() {
		try {
			const response = await fetch("https://api.country.is/");
			const responseJson: { country: string } = await response.json();

			this.countryCode = responseJson.country.toLowerCase();
		} catch (e) {
			console.error(`Error getting countries for: ${e}`);
		}
	}
}
